// @/api/base.js

function normalizePath(path = "") {
  if (!path) {
    return "";
  }
  return path.startsWith("/") ? path : `/${path}`;
}

function joinUrl(baseUrl, path = "") {
  if (!baseUrl) {
    return normalizePath(path);
  }
  const normalizedBase = baseUrl.replace(/\/+$/, "");
  const normalizedPath = normalizePath(path);
  return `${normalizedBase}${normalizedPath}`;
}

function isAbsoluteUrl(url) {
  return /^(https?:)?\/\//i.test(url);
}

function getUrlOrigin(url) {
  try {
    return new URL(url).origin;
  } catch (error) {
    return (url || "").replace(/^(https?:\/\/[^/]+).*$/i, "$1").replace(/\/+$/, "");
  }
}

function normalizeStaticAssetUrl(path = "", serverBaseUrl = "") {
  const staticPath = "/smartnecklace/static";
  const serverOrigin = getUrlOrigin(serverBaseUrl);
  if (!path || !serverOrigin) {
    return path || "";
  }

  try {
    const url = new URL(path);
    if (url.pathname.startsWith(staticPath)) {
      return `${serverOrigin}${url.pathname}${url.search}${url.hash}`;
    }
    return path;
  } catch (error) {
    const normalizedPath = normalizePath(path);
    if (normalizedPath.startsWith(staticPath)) {
      return `${serverOrigin}${normalizedPath}`;
    }
    return null;
  }
}

export default {
  SERVER_OPTIONS: {
    northwest: {
      name: "服务器1",
      webUrl: "https://www.dibox.com.cn/cmmu",
      // webUrl: "https://www.dibox.com.cn/smartnecklace-client",
      // webUrl: "https://www.chip-nova.cn/nw/cmmu",
    },
    main: {
      name: "服务器2",
      webUrl: "https://www.chip-nova.cn/cmmu",
    },
    dev: {
      name: "本地服务器",
      webUrl: "http://localhost:10032",
    },
  },

  currentServer: null,

  init() {
    const savedKey = localStorage.getItem("selectedServer");

    this.currentServer =
      this.SERVER_OPTIONS[savedKey] || this.SERVER_OPTIONS.northwest;
  },

  getUsrBaseUrl() {
    if (!this.currentServer) {
      return this.SERVER_OPTIONS.northwest.webUrl;
    }
    return this.currentServer.webUrl;
  },

  getAssetBaseUrl() {
    return this.currentServer === this.SERVER_OPTIONS.dev
      ? this.SERVER_OPTIONS.main.webUrl
      : this.getUsrBaseUrl();
  },

  getUrl(path = "") {
    return joinUrl(this.getUsrBaseUrl(), path);
  },

  getAssetUrl(path = "") {
    if (!path) {
      return "";
    }
    // Static assets are shared by each deployment under the same path; only the server origin follows the user's server selection.
    const staticAssetUrl = normalizeStaticAssetUrl(path, this.getAssetBaseUrl());
    if (staticAssetUrl) {
      return staticAssetUrl;
    }
    if (isAbsoluteUrl(path)) {
      return path;
    }
    return this.getUrl(path);
  },

  setServer(key) {
    if (this.SERVER_OPTIONS[key]) {
      this.currentServer = this.SERVER_OPTIONS[key];
      localStorage.setItem("selectedServer", key);
    } else {
      console.warn(`无效的服务器选项: ${key}`);
    }
  },
};
